const AUTH_MODE_SSO = 'sso';

export const isSsoEnabled = () => {
  const mode = ( process.env.REACT_APP_AUTH_MODE || AUTH_MODE_SSO ).toLowerCase();
  return mode === AUTH_MODE_SSO;
};

export default {
  isSsoEnabled,
};
